import { render } from "./Publisher.vue?vue&type=template&id=3422e4fe"
import script from "./Publisher.vue?vue&type=script&lang=js"
export * from "./Publisher.vue?vue&type=script&lang=js"

import exportComponent from "/root/tools-store-ranking-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__